/**
 * Detects the user's browser by checking user agent data.
 * 
 * @function
 * @name detectBrowser
 * @returns {string} - The detected browser name.
 */

export const detectBrowser = (): string => {
    const userAgent = window.navigator.userAgent;
    const isIE = userAgent.indexOf('Trident') > -1 || userAgent.indexOf('MSIE') > -1;
    const isEdge = userAgent.indexOf('Edg') > -1 || userAgent.indexOf('Edge') > -1;
    const isOpera = window.navigator.userAgent.indexOf('Opera') > -1 || window.navigator.userAgent.indexOf('OPR') > -1;
    const isFirefox = userAgent.indexOf('Firefox') > -1;
    const isChrome = userAgent.indexOf('Chrome') > -1 && !isEdge && !isOpera;
    const isSafari = userAgent.indexOf('Safari') > -1 && !isChrome && !isEdge && !isOpera;

    if (isIE) {
        return 'Internet Explorer';
    } else if (isEdge) {
        return 'Edge';
    } else if (isOpera) {
        return 'Opera';
    } else if (isFirefox) {
        return 'Firefox';
    } else if (isChrome) {
        return 'Chrome';
    } else if (isSafari) {
        return 'Safari';
    }
    return 'Unknown Browser';
};